import { UserDM } from "./user_dm";
export class OrganizationDM {
  constructor({
    pk = 0,
    name = "",
    slug = "",
    has_kriya_permission = false,
    has_organization_group = false,
    organization_group = null,
    use_icon = false,
    organization_icon = "",
    subscription_type = 0,
    organization_size = 0,
    point_reward = "",
    created = "",
    updated = "",
    admin = {},
    users = [],
  }) {
    this.pk = pk;
    this.name = name;
    this.slug = slug;
    this.has_kriya_permission = has_kriya_permission;
    this.has_organization_group = has_organization_group;
    this.organization_group = organization_group;
    this.use_icon = use_icon;
    this.organization_icon = organization_icon;
    this.subscription_type = subscription_type;
    this.organization_size = organization_size;
    this.point_reward = point_reward;
    this.created = created;
    this.updated = updated;
    this.admin = admin;
    this.users = users;
  }

  static fromJson(json) {
    let organization = new OrganizationDM({
      pk: json["pk"],
      name: json["name"],
      slug: json["slug"],
      has_kriya_permission: json["has_kriya_permission"],
      has_organization_group: json["has_organization_group"],
      organization_group: json["organization_group"],
      use_icon: json["use_icon"],
      organization_icon: json["organization_icon"],
      subscription_type: json["subscription_type"],
      organization_size: json["organization_size"],
      point_reward: json["point_reward"],
      created: json["created"],
      updated: json["updated"],
    });
    organization.admin = UserDM.fromJson(json["admin"]);
    let users = json["users"];
    if (Array.isArray(users)) {
      organization.users = [];

      users.forEach((user) => {
        organization.users.push(UserDM.fromJson(user));
      });
    }

    return organization;
  }
}
